// コンビニ名とAPIに渡すコードのリスト

export default [
  { name: 'セブンイレブン', code: 'seven' },
  { name: 'ファミリーマート', code: 'famima' },
  { name: 'ローソン', code: 'lawson' },
  { name: 'ミニストップ', code: 'mini' },
]
